const TWC_BASE = "https://api.weather.com/v3/TileServer";
const SATRAD = "satrad";

export async function fetchWeatherTimeslices(): Promise<number[]> {
  const apiKey = process.env.REACT_APP_OPENWEATHER_API_KEY;
  try {
    const res = await fetch(
      `${TWC_BASE}/series/productSet/PPAcore?apiKey=${apiKey}&filter=${SATRAD}`
    );
    if (!res.ok) return [];
    const data = await res.json();
    const series: { ts: number }[] | undefined =
      data?.seriesInfo?.[SATRAD]?.series;
    if (!series?.length) return [];
    // reverse so animation plays oldest → newest (most recent = last frame)
    return [...series].reverse().map((s) => s.ts);
  } catch {
    return [];
  }
}

export function buildWeatherTileUrl(
  ts: number,
  coord: { x: number; y: number },
  zoom: number
): string {
  const apiKey = process.env.REACT_APP_OPENWEATHER_API_KEY;
  return `${TWC_BASE}/tile/${SATRAD}?ts=${ts}&xyz=${coord.x}:${coord.y}:${zoom}&apiKey=${apiKey}`;
}
